import moment from 'moment';
import { Card } from 'primereact/card';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Messages } from 'primereact/messages';
import { TabPanel, TabView } from 'primereact/tabview';
import React from 'react';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseDetailsContainer from '../baseContainers/BaseDetailsContainer';
import ActionButton from '../components/ActionButton';
import ActionLink from '../components/ActionLink';
import BannerComponent from '../components/BannerComponent';
import { CustomDialog } from '../components/CustomDialog';
import DivContainer from '../components/DivContainer';
import MenuItemIcon from '../components/MenuItemIcon';
import TooltipComponent from '../components/TooltipComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import CardDataModel from '../model/CardDataModel';
import CardRequiredModel from '../model/CardRequiredModel';
import LimitModel from '../model/LimitModel';
import CardService from '../services/CardService';
import CardUserService from '../services/CardUserService';
import SettingService from '../services/SettingService';
import TransactionService from '../services/TransactionService';
import AllTrxLimitEditDialog from './AllTrxLimitEditDialog';
import CardAuthorizeDialog from './CardAuthorizeDialog';
import CardChangeBlockedDialog from './CardChangeBlockedDialog';
import CardDataEditDialog from './CardDataEditDialog';
import CardKindDialog from './CardKindDialog';
import CardManageDialog from './CardManageDialog';
import CardRenewDialog from './CardRenewDialog';
import CardUnauthorizeDialog from './CardUnauthorizeDialog';
import OrderPlasticConfirmationDialog from './OrderPlasticConfirmationDialog';
import PinEditDialog from './PinEditDialog';
import RequiredDialog from './RequiredDialog';
import VisitLimitEditDialog from './VisitLimitEditDialog';
import AuthService from '../services/AuthService';
import HybridCardUserApprovalsDialog from './HybridCardUserApprovalsDialog';
import CardHighwaysUpdateDialog from './CardHighwaysUpdateDialog';
import MotorwayPaymentCardModel from '../model/MotorwayPaymentCardModel';
import { Checkbox } from 'primereact/checkbox';
import ApprovalsAcceptationDialog from './ApprovalsAcceptationDialog';
import AdditionalToolsService from '../services/AdditionalToolsService';

class CardDetailsContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props);
        this.service = new CardService();
        this.transactionService = new TransactionService();
        this.authService = new AuthService();
        this.additionalService = new AdditionalToolsService();
        let activeIndex = this.readCookie(`user-details-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.state = {
            elementId: this.props.elementId,
            activeIndex: parseInt(activeIndex),
            yourCardCount: 0,
            virtualCardUsersCount: 0,
            stepView: 'LIST',
            element: undefined,
            lastTransaction: undefined,
            cardDataEditDialogVisibile: false,
            allTrxLimitEditionVisibile: false,
            visitLimitEditionVisibile: false,
            requiredDialogVisibile: false,
            fleetGoodGroupDialogVisibile: false,
            motorwaysDialogVisibile: false,
            backOffAuthVisibile: false,
            changeBlockedVisibile: false,
            renewVisibile: false,
            pinEditVisibile: false,
            orderPlasticConfirmationVisibile: false,
            authorizationVisibile: false,
            cardKindVisibile: false,
            cardList: [],
            orderPlasticCardPrice: '',
            mpkTooltipVisible: false,
            loadingLastTransaction: true,
            confirmDialog: { visible: false },
            //hybridAgreementsVisibile: false,
            approvals:[],
            highwaysApprovals:[],
            vehicleTypeOpt:[],
            vehicleCategoryOpt:[]            
        };
        this.cardUserService = new CardUserService();
        this.settingService = new SettingService();
        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleGoToDetail = this.handleGoToDetail.bind(this);
        this.handleOpenCardDataEditDialog = this.handleOpenCardDataEditDialog.bind(this);
        this.handleAllTrxEditionOpen = this.handleAllTrxEditionOpen.bind(this);
        this.handleVisitLimitEditionOpen = this.handleVisitLimitEditionOpen.bind(this);
        this.handleAllTrxEditionClose = this.handleAllTrxEditionClose.bind(this);
        this.handleOpenRequiredDialog = this.handleOpenRequiredDialog.bind(this);
        this.handleCloseRequiredDialog = this.handleCloseRequiredDialog.bind(this);
        this.handleOpenFleetGoodGroupDialog = this.handleOpenFleetGoodGroupDialog.bind(this);
        this.handleCloseFleetGoodGroupDialog = this.handleCloseFleetGoodGroupDialog.bind(this);
        this.handleOpenUnauthorizeDialog = this.handleOpenUnauthorizeDialog.bind(this);
        this.handleCloseBackOffAuthDialog = this.handleCloseBackOffAuthDialog.bind(this);
        this.handleOrderPlasticConfirmationOpen = this.handleOrderPlasticConfirmationOpen.bind(this);
        this.handleOrderPlasticConfirmationClose = this.handleOrderPlasticConfirmationClose.bind(this);
        this.handleEditPinOpen = this.handleEditPinOpen.bind(this);
        this.handleEditPinClose = this.handleEditPinClose.bind(this);
        this.statusTemplate = this.statusTemplate.bind(this);
        this.expirationDateTemplate = this.expirationDateTemplate.bind(this);
        this.cardTypeTemplate = this.cardTypeTemplate.bind(this);
        this.managementActionTemplate = this.managementActionTemplate.bind(this);
        this.handleOrderPlasticCard = this.handleOrderPlasticCard.bind(this);
        this.handleOpenAuthorizeDialog = this.handleOpenAuthorizeDialog.bind(this);
        this.handleCloseAuthorizationDialog = this.handleCloseAuthorizationDialog.bind(this);
        this.handleOpenChangeBlockedDialog = this.handleOpenChangeBlockedDialog.bind(this);
        this.handleCloseChangeBlockedDialog = this.handleCloseChangeBlockedDialog.bind(this);
        this.handleShowTooltip = this.handleShowTooltip.bind(this);
        this.handleHideTooltip = this.handleHideTooltip.bind(this);
        this.handleCardKindDialogOpen = this.handleCardKindDialogOpen.bind(this);
        this.handleCardKindDialogClose = this.handleCardKindDialogClose.bind(this);
        this.updateElementAfterCardDataEdition = this.updateElementAfterCardDataEdition.bind(this);
    }

    componentDidMount() {
        const { t } = this.props;
        super.componentDidMount();
        if (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') {
        this.getHybridCardUserApprovalsToAccept();
        }
        let activeIndex = this.readCookie(`user-details-activeIndex`);
        if (activeIndex === undefined || activeIndex === null || activeIndex === '') {
            activeIndex = 0;
        }
        this.service
            .getCardDetailsImages()
            .then((response) => {
                this.setState({
                    bannerImage: response.bannerImage,
                });
            })
            .catch(() => {
                this.unblockUi();
                this.showErrorMessage(t('error.getCardDetailsImagesError'));
            });
        this.settingService
            .getVehicleTypes()
            .then((vehicleTypeOpt) => {
                if (this._isMounted) {
                    this.setState({
                        vehicleTypeOpt,
                    });
                }
            })
            .catch(() => { this.showErrorMessage('Nie udało się pobrać listy typów pojazdów'); });
        this.setState({ activeIndex: parseInt(activeIndex) });

        this.settingService
        .getVehicleCategories()
        .then((vehicleCategoryOpt) => {
            if (this._isMounted) {
                this.setState({
                    vehicleCategoryOpt,
                });
            }
        })
        .catch(() => {  this.showErrorMessage('Nie udało się pobrać listy kategorii pojazdów');});
    this.setState({activeIndex: parseInt(activeIndex)});

    //highways approvals
        this.additionalService.getHighwayAllTerms()
            .then((res) => {
                this.setState({
                    highwaysApprovals: res,
                })
            })
            .catch((err) => {
                this.showErrorMessage("Nie udało sie pobrać regulaminów dla przejazdów autostradowych")
            })

    }

    initAfterSetElement() {
        super.initAfterSetElement();
        const { t } = this.props;
        if (this.isUserHasAnyPermission('PERMISSION_VIEW_TRANSACTIONS', 'PERMISSION_EDIT_TRANSACTIONS')) {
            this.transactionService
                .getLastTransactionForCardId(this.state.element.petraId)
                .then((lastTransaction) => {
                    lastTransaction.date = lastTransaction.date ? new Date(lastTransaction.date) : undefined;
                    this.setState({ lastTransaction, loadingLastTransaction: false });
                })
                .catch((err) => {
                    this.setState({ loadingLastTransaction: false });
                    this.showErrorMessage(t('error.getLastTransactionInfoError'));
                });
        } else {
            this.setState({ loadingLastTransaction: false });
        }
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }

    getHybridCardUserApprovalsToAccept() {

        this.service.getHybridCardUserApprovalsToAcceptBeforeAuthorization()
            .then((response) => this.setState({ approvals: response }))
            .catch((error) => {
                this.showErrorMessage("Wystąpił błąd podczas pobierania regulaminów dla uzytkownika karty hybrydowej")
            })
    }

    getOnlyNotAcceptedHybridCardUserApprovals(){
        const listOfAcceptedTerms = this.authService.getHybridCardUserAcceptedTerms();
      return  this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId));
    }


    checkTokenIfAllHybridAgreementNotAccepted() {
        const hybridCardUser = (this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') ;
        if(hybridCardUser === true){
            const listOfAcceptedTerms = this.authService.getHybridCardUserAcceptedTerms();
            return this.state.approvals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId)).length > 0;
        } else {
            return false;
        }
    }


    initBeforeSetElement() {
        const { t } = this.props;
        this.service
            .getCardOrderPrice()
            .then((res) => this.setState({ orderPlasticCardPrice: res.price }))
            .catch((err) => this.showErrorMessage(t('error.orderPlasticCardPriceError')));
    }

    updateElementAfterCardDataEdition(res) {
        this.updateElement(res);
    }

    updateElement(res) {
        res.expirationDate = res.expirationDate ? new Date(res.expirationDate) : undefined;
        res.virtualExpirationDate = res.expirationDate ? new Date(res.expirationDate) : undefined;
        let plasticExpired = res.expirationDate ? !moment(res.expirationDate).isSameOrAfter(moment.now(), 'day') : false;
        let virtualExpired = res.virtualExpirationDate ? !moment(res.virtualExpirationDate).isSameOrAfter(moment.now(), 'day') : false;
        let plastcStatus = plasticExpired ? 'EXPIRED' : res.status;
        let virtualStatus = virtualExpired
            ? 'EXPIRED'
            : !res.authorized
                ? 'UNAUTHORIZED'
                : res.status === 'TO_BE_PRINTED'
                    ? 'ACTIVE'
                    : res.status;
        this.setState(
            {
                element: res,
                cardList: res.hasPlasticCard
                    ? [
                        {
                            cardType: 'PLASTIC',
                            status: plastcStatus,
                            phoneNumber: res.phoneNumber,
                            expirationDate: res.expirationDate,
                            indefinitely: res.expirationDate ? false : true,
                        },
                        {
                            cardType: 'VIRTUAL',
                            status: virtualStatus,
                            phoneNumber: res.phoneNumber,
                            expirationDate: res.virtualExpirationDate,
                            indefinitely: res.virtualExpirationDate ? false : true,
                        },
                    ]
                    : [
                        {
                            cardType: 'VIRTUAL',
                            status: virtualStatus,
                            phoneNumber: res.phoneNumber,
                            expirationDate: res.virtualExpirationDate,
                            indefinitely: res.virtualExpirationDate ? false : true,
                        },
                    ],
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    handleTabChange(e) {
        this.setState(
            {
                activeIndex: e.index,
            },
            () => {
                this.saveCookie(`user-details-activeIndex`, this.state.activeIndex);
            }
        );
    }

    handleShowTooltip() {
        this.setState({ mpkTooltipVisible: true });
    }

    handleHideTooltip() {
        this.setState({ mpkTooltipVisible: false });
    }

    readCookie(cookieName) {
        return sessionStorage.getItem(cookieName);
    }

    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }

    render() {
        return (
            <React.Fragment>
                <Messages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi tag='div' blocking={!!this.state.blocking || !!this.state.loading} loader={this.loader}>
                    {!!this.state.blocking || !!this.state.loading ? null : this.renderView()}
                </BlockUi>
            </React.Fragment>
        );
    }
    renderFleetGoodGroupLimit(effectiveActiveIndex, limitType) {
        const { t } = this.props;
        let limitName;
        if (effectiveActiveIndex === 0) {
            if (limitType === 'quantityLimit') {
                limitName = 'fuelQuantityLimit';
            } else if (limitType === 'amountLimit') {
                limitName = 'fuelAmountLimit';
            }
        } else if (effectiveActiveIndex === 2) {
            limitName = 'notFuelAmountLimit';
            limitType = 'amountLimit';
        } else if (effectiveActiveIndex === 1) {
            limitName = 'serviceAmountLimit';
            limitType = 'amountLimit';
        }
        return !!this.state.element && !!this.state.element[limitName] && this.state.element[limitName].type ? (
            <React.Fragment>
                <InputTextComponent
                    id={limitName}
                    name={limitName}
                    label={t(`cards.${limitType}`)}
                    value={`${this.state.element[limitName].value} / ${this.state.element[limitName].type === 'DAILY' ? t('day') : t('month')
                        }`}
                    validator={this.validator}
                    validators='required'
                    onChange={this.handleChange}
                    viewMode={'VIEW'}
                    min={0}
                    inputStyle={{ width: '100%' }}
                    colClass='flex-inputs'
                />
            </React.Fragment>
        ) : null;
    }

    renderView() {
        const { t } = this.props;
        return this.state.element ? (
            <React.Fragment>
                <CustomDialog
                    visible={this.state.confirmDialog?.visible}
                    onHide={() => this.setConfirmDialogVisibility(false)}
                    closeable
                    className='confirm-dialog-width'
                    renderHeader={() => {
                        const { t } = this.props;
                        return (
                            <DivContainer colClass='row'>
                                <DivContainer colClass='col-12'>
                                    <img
                                        className='confirm-dialog-icon'
                                        alt={t(`${this.state.confirmDialog?.header}`)}
                                        src={`/images/${this.state.confirmDialog.iconSvg}.svg`}
                                    />
                                </DivContainer>
                                <DivContainer colClass='col-12'>
                                    <label key='confirm-dialog-label'>{t(`${this.state.confirmDialog?.header}`)}</label>
                                </DivContainer>
                            </DivContainer>
                        );
                    }}
                >
                    <Card
                        footer={() => {
                            const { t } = this.props;
                            return (
                                <div className='footer-dialog-button-container'>
                                    <ActionButton
                                        label={t('details.close')}
                                        variant='button save-button blue'
                                        handleClick={(e) => {
                                            e.preventDefault();
                                            this.setConfirmDialogVisibility(false);
                                        }}
                                    />
                                </div>
                            );
                        }}
                    >
                        <div className='confirm-dialog-label'>{t(`${this.state.confirmDialog?.message}`)}</div>
                    </Card>
                </CustomDialog>
                <CardDataEditDialog
                    className='card-list-manage-dialog'
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    element={CardDataModel.copy(this.state.element)}
                    onHide={() => this.handleCloseEditClientDialog()}
                    visible={this.state.cardDataEditDialogVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) =>
                        this.handleCloseEditClientDialog(() => {

                            this.blockUi();
                            const messageList = [];
                            const errorsList = [];
                            if(res.token){
                                this.authService.setToken(res.token);
                            }
                            if (res.model.phoneUpdateSuccess === true) {
                                messageList.push(this.getSuccessMessage(t('cards.phoneUpdateSuccess')));
                            }
                            if (res.model.cardDataSuccess === true) {
                                messageList.push(this.getSuccessMessage(t('cards.cardDataEditionSuccess')));
                            }
                            if (res.model.phoneUpdateError === true) {
                                messageList.push(this.getErrorMessage(t('error.phoneUpdateError')));
                                errorsList.push(t('error.phoneUpdateError'));
                            }
                            if (res.model.cardDataError === true) {
                                messageList.push(this.getErrorMessage(t('error.updateCardDataError')));
                                errorsList.push(t('error.updateCardDataError'));
                            }
                            this.showMessagesList(messageList, errorsList);
                            this.updateElementAfterCardDataEdition(res.model);
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseEditClientDialog(() => {
                            this.showErrorMessage(t('error.updateCardDataError'));
                        });
                    }}
                    cardKind={this.state.element.cardKind}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                    vehicleTypeOpt={this.state.vehicleTypeOpt}
                    agreementsToAccept={this.getOnlyNotAcceptedHybridCardUserApprovals()}
                />
                <AllTrxLimitEditDialog
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    limit={this.state.element.monthlyAmountLimit}
                    phoneNumber={this.state.element.phoneNumber}
                    onHide={() => this.handleAllTrxEditionClose()}
                    visible={this.state.allTrxLimitEditionVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) => {
                        this.handleAllTrxEditionClose(() => {
                            this.blockUi();
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.allTrxLimitUpdateSuccess'));
                        });
                    }}
                    handleError={(err) => {
                        this.handleAllTrxEditionClose(() => {
                            this.showErrorMessage(t('error.updateLimitError'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <VisitLimitEditDialog
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    limit={this.state.element.dailyVisitLimit}
                    onHide={() => this.handleVisitLimitEditionClose()}
                    visible={this.state.visitLimitEditionVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) => {
                        this.handleVisitLimitEditionClose(() => {
                            this.blockUi();
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.visitLimitUpdateSuccess'));
                        });
                    }}
                    handleError={(err) => {
                        this.handleVisitLimitEditionClose(() => {
                            this.showErrorMessage(t('error.updateLimitError'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <PinEditDialog
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    pin={this.state.element.pin}
                    onHide={() => this.handleEditPinClose()}
                    visible={this.state.pinEditVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) => {
                        this.handleEditPinClose(() => {
                            this.blockUi();
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.pinEditSuccess'));
                        });
                    }}
                    handleError={(err) => {
                        this.handleEditPinClose(() => {
                            this.showErrorMessage(t('error.pinEditError'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <CardKindDialog
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    cardKind={{ label: t(`CardKind.${this.state.element.cardKind}`), enumValue: this.state.element.cardKind }}
                    onHide={() => this.handleCardKindDialogClose()}
                    visible={this.state.cardKindVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) => {
                        this.handleCardKindDialogClose(() => {
                            this.blockUi();
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.cardKindEditSuccess'));
                        });
                    }}
                    handleError={(err) => {
                        this.handleCardKindDialogClose(() => {
                            this.showErrorMessage(t('error.cardKindEditError'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <RequiredDialog
                    mainRef={this.props.mainRef}
                    cardNumbers={[this.state.element.cardNumber]}
                    element={CardRequiredModel.copy(this.state.element)}
                    cardKind={this.state.element.cardKind}
                    onHide={() => this.handleCloseRequiredDialog()}
                    visible={this.state.requiredDialogVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(res) =>
                        this.handleCloseRequiredDialog(() => {
                            this.blockUi();
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.requiredUpadateSuccessMessage'));
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseRequiredDialog(() => {
                            this.showErrorMessage(t('error.requiredUpadateError'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <CardManageDialog
                    mainRef={this.props.mainRef}
                    element={LimitModel.copy(this.state.element)}
                    onHide={(e) => this.handleCloseFleetGoodGroupDialog()}
                    visible={!!this.state.fleetGoodGroupDialogVisibile && !isNaN(this.state.fggActiveIndex)}
                    className='card-limit-dialog'
                    viewMode={'EDIT'}
                    handleSuccess={(res) =>
                        this.handleCloseFleetGoodGroupDialog(() => {
                            this.updateElement(res);
                            this.showSuccessMessage(t('cards.limitsUpadateSuccessMessage'));
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseFleetGoodGroupDialog(() => {
                            this.unblockUi();
                            this.showErrorMessage(t('error.limitsEditionError'));
                        });
                    }}
                    activeIndex={this.state.fggActiveIndex}
                    cards={[this.state.element.cardNumber]}
                    plasticCard={this.state.element.hasPlasticCard === true && this.state.element.multiEnergeticCard === false}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                {
                  <CardHighwaysUpdateDialog
                  mainRef={this.props.mainRef}
                  element={MotorwayPaymentCardModel.assignWithCategory(this.state.element, this.state.vehicleCategoryOpt)}
                  onHide={(e) => this.handleCloseHighwayPaymentsDialog()}
                  visible={!!this.state.motorwaysDialogVisibile }
                  viewMode={'EDIT'}
                  handleSuccess={(res) =>{
                      this.handleCloseHighwayPaymentsDialog(() => {
                         this.unblockUi();
                          this.showSuccessMessage(t('cards.highwaysCardActionSuccess'));
                      })}
                  }
                  handleError={(err, actionType) => {
                      this.handleCloseHighwayPaymentsDialog(() => {
                          this.unblockUi();
                          if (err.errorCode === 'HIGHWAY_ACTIVATE_SAFO_VERIFICATION_ERROR' || err.errorCode === 'HIGHWAY_ACTIVATE_CARD_PROCESSING_ERROR' || err.errorCode === 'HIGHWAY_DEACTIVATE_SAFO_VERIFICATION_ERROR' || err.errorCode === 'HIGHWAY_DEACTIVATE_CARD_PROCESSING_ERROR') {
                                this.showErrorMessage(err.message);
                          } else {
                                this.showErrorMessage(t('error.highwaysCardActivationFailed'))
                          }
                      });
                  }}
                  cards={this.state.element.petraId}
                  plasticCard={this.state.element.hasPlasticCard === true && this.state.element.multiEnergeticCard === false}
                  blockUi={this.blockUi}
                  unblockUi={this.unblockUi}
                  showMessage={this.showMessage}
                  embedded
                  _isMounted={this._isMounted}
                  vehicleCategoryOpt= {this.state.vehicleCategoryOpt}
                  afterSave={(res) =>{
                        if (res !== undefined) {
                            this.setState((prevState) => ({
                            
                                element:{
                                    ...prevState.element,
                                    highwayEnabled: res.response.highwayEnabled,
                                    highwayVehicleType: res.response.vehicleCategory
                                }
                            }));
                        }
                    }
                  }
              />
                }

                {this.state.highwaysAgreementsDialogVisibile ? (
                    <ApprovalsAcceptationDialog
                        id={`agreement-term-dialog-update-card`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        approvals={this.state.highwaysApprovals}
                        visible={this.state.highwaysAgreementsDialogVisibile}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showSuccessMessage={this.showSuccessMessage}
                        showErrorMessage={this.showErrorMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => { }}
                        closable={false}
                        onHide={() => this.handleHighwaysAgreementDialogClose()}
                    ></ApprovalsAcceptationDialog>) : null}
                <CardUnauthorizeDialog
                    mainRef={this.props.mainRef}
                    phoneNumber={this.state.element.phoneNumber}
                    cardNumber={this.state.element.cardNumber}
                    fromCardDetailsMode={true}
                    onHide={this.handleCloseBackOffAuthDialog}
                    visible={this.state.backOffAuthVisibile}
                    viewMode={this.state.dialogViewMode}
                    handleSuccess={(card) =>
                        this.handleCloseBackOffAuthDialog(() => {
                            this.updateElement(card);
                            this.showSuccessMessage(t('cards.successBackOffAuth'));
                            this.setConfirmDialogVisibility(
                                true,
                                'cards.unauthorize.confirmDialogHeader',
                                'cards.unauthorize.confirmDialogMessage',
                                'ico_confirm_dialog_success'
                            );
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseBackOffAuthDialog(() => {
                            this.showErrorMessage(t('error.errorBackOffAuth'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <CardAuthorizeDialog
                    mainRef={this.props.mainRef}
                    phoneNumber={this.state.element.phoneNumber}
                    cardNumber={this.state.element.cardNumber}
                    onHide={this.handleCloseAuthorizationDialog}
                    viewMode='EDIT'
                    visible={this.state.authorizationVisibile}
                    handleSuccess={(card) =>
                        this.handleCloseAuthorizationDialog(() => {
                            if(card.token){
                                this.authService.setToken(card.token);
                            }
                            this.updateElement(card.model);
                            this.showSuccessMessage(t('cards.successAuthorize'));
                            this.setConfirmDialogVisibility(
                                true,
                                'cards.authorize.confirmDialogHeader',
                                'cards.authorize.confirmDialogMessage',
                                'ico_confirm_dialog_success'
                            );
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseAuthorizationDialog(() => {
                            this.showErrorMessage(t('error.errorAuthorize'));
                        });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                    agreementsToAccept={this.getOnlyNotAcceptedHybridCardUserApprovals()}
                />
                <CardChangeBlockedDialog
                    mainRef={this.props.mainRef}
                    cardNumber={this.state.element.cardNumber}
                    onHide={this.handleCloseChangeBlockedDialog}
                    visible={this.state.changeBlockedVisibile}
                    blockCard={this.state.element.status !== 'LOCKED' && this.state.element.status !== 'BLOCKED'}
                    handleSuccess={(card) =>
                        this.handleCloseChangeBlockedDialog(() => {
                            let blockCard = this.state.element.status !== 'LOCKED' && this.state.element.status !== 'BLOCKED';
                            this.updateElement(card);
                            this.setConfirmDialogVisibility(
                                true,
                                `cards.${blockCard ? 'block' : 'unblock'}.confirmDialogHeader`,
                                `cards.${blockCard ? 'block' : 'unblock'}.confirmDialogMessage`,
                                'ico_confirm_dialog_success'
                            );
                        })
                    }
                    handleError={(err) => {
                        this.handleCloseChangeBlockedDialog(() => { });
                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                />
                <CardRenewDialog
                    mainRef={this.props.mainRef}
                    cardNumber={this.state.element.cardNumber}
                    onHide={() => this.setState({ renewVisibile: false })}
                    visible={this.state.renewVisibile}
                    afterSave={(res) =>  { 
                        if(res.cardNumber !== null && res.cardNumber !== undefined && res.cardNumber !== this.state.element.cardNumber){
                            const newHref = `/card-details/${res.cardNumber}`;
                            this.props.history.replace(`${newHref}`);
                        }
                       
                        this.setState({ renewVisibile: false }, () => this.updateElement(res))


                    }}
                    blockUi={this.blockUi}
                    unblockUi={this.unblockUi}
                    showMessage={this.showMessage}
                    embedded
                    _isMounted={this._isMounted}
                    hasPlastic={this.state.element.hasPlasticCard === true }
                />
                {this.isUserHasAnyPermission('PERMISSION_VIEW_PROFILE', 'PERMISSION_EDIT_PROFILE') && (
                    <OrderPlasticConfirmationDialog
                        className='confirm-dialog-width'
                        mainRef={this.props.mainRef}
                        cardNumbers={[this.state.element.cardNumber]}
                        onHide={() => this.handleOrderPlasticConfirmationClose()}
                        visible={this.state.orderPlasticConfirmationVisibile}
                        handleFormSubmit={this.handleOrderPlasticCard}
                        orderPlasticCardPrice={this.state.orderPlasticCardPrice}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.showMessage}
                        embedded
                        _isMounted={this._isMounted}
                    />
                )}
                {this.state.hybridAgreementsVisibile ? (
                    <HybridCardUserApprovalsDialog
                        id={`agreement-term-dialog`}
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        approvals={this.state.approvals}
                        visible={this.state.hybridAgreementsVisibile}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                        showMessage={this.props.showMessage}
                        resizable={true}
                        className='agreement-term-dialog'
                        key={`agreement-term-dialog`}
                        handleReject={() => { }}
                        closable={false}
                        onHide={() => this.handleCloseHybridAgreementDialog()}
                        handleError={err => this.showErrorMessage(err)}
                    ></HybridCardUserApprovalsDialog>) : null}
                {this.renderDetailsHeader()}
                <div className='container-fluid card-details-container'>
                    <TabView activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} className='user-details-card-tab'>
                        <TabPanel header={`${t('cards.userDetails.cardData')}`}>
                            <DivContainer colClass='dashboard'>
                                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                            <Card header={this.renderAvTransactionCountHeader()}>
                                                <BlockUi
                                                    tag='div'
                                                    blocking={this.state.loadingLastTransaction}
                                                    loader={this.loader}
                                                    loaderType='small-loader card-loader'
                                                    horizontal
                                                >
                                                    {!!this.state.lastTransaction &&
                                                        this.state.lastTransaction?.diffMonthCount !== undefined &&
                                                        this.state.lastTransaction?.diffMonthCount !== null ? (
                                                        <DivContainer colClass='row trx'>
                                                            <h1 className='avTrx col-4'>{this.state.lastTransaction?.currentCount}</h1>
                                                            {this.state.lastTransaction?.diffMonthCount > 0 ? (
                                                                <div className='avTrx-details-box col-8'>
                                                                    <span className={'avRelativceTr-plus col-12'}>
                                                                        <MenuItemIcon
                                                                            alt=''
                                                                            className={`icon-svg left`}
                                                                            iconSvg={'ico_up_arrow'}
                                                                        />
                                                                    </span>
                                                                    <label key='diffMonthCount' className='avTrx-details-label col-12'>
                                                                        {t('cards.userDetails.overLastMonth')}
                                                                    </label>
                                                                </div>
                                                            ) : this.state.lastTransaction?.diffMonthCount < 0 ? (
                                                                <div className='avTrx-details-box col-8'>
                                                                    <span className={'avRelativceTr-minus col-12'}>
                                                                        <MenuItemIcon
                                                                            alt=''
                                                                            className={`icon-svg left`}
                                                                            iconSvg={'ico_down_arrow'}
                                                                        />
                                                                    </span>
                                                                    <label key='diffMonthCount' className='avTrx-details-label col-12'>
                                                                        {t('cards.userDetails.underLastMonth')}
                                                                    </label>
                                                                </div>
                                                            ) : null}
                                                        </DivContainer>
                                                    ) : (
                                                        <DivContainer colClass='row trx'>
                                                            <h1 className='avTrx col-4'>0</h1>
                                                        </DivContainer>
                                                    )}
                                                </BlockUi>
                                            </Card>
                                        </DivContainer>
                                        {this.state.lastTransaction?.transactionType !== null &&
                                            this.state.lastTransaction?.transactionType !== undefined &&
                                            this.state.lastTransaction?.transactionType !== 2 ? (
                                            <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                <Card header={this.renderLastTransactionHeader()}>
                                                    <BlockUi
                                                        tag='div'
                                                        blocking={this.state.loadingLastTransaction}
                                                        loader={this.loader}
                                                        loaderType='small-loader card-loader'
                                                        horizontal
                                                    >
                                                        <div className='row '>
                                                            {!!this.state.lastTransaction && !!this.state.lastTransaction.date ? (
                                                                <div className='col-12'>
                                                                    {this.state.lastTransaction?.positions &&
                                                                        this.state.lastTransaction?.positions.length
                                                                        ? this.state.lastTransaction?.positions.map((p, index) => {
                                                                            return (
                                                                                <div className='row last-transaction-row'>
                                                                                    <h1
                                                                                        id={`last-trx-quantity-${index}`}
                                                                                        className='lastTrx col-6'
                                                                                    >
                                                                                        <NumberFormat
                                                                                            value={p.quantity}
                                                                                            displayType={'text'}
                                                                                            thousandSeparator=' '
                                                                                            decimalSeparator=','
                                                                                            fixedDecimalScale
                                                                                            decimalScale={2}
                                                                                            renderText={(value) => value}
                                                                                            //suffix={this.state.lastTransaction?.transactionType === 3 ?  " " +t(`measureUnit.${this.state.lastTransaction?.quantityUnit}`)  : ` ${t('cards.l')}`}
                                                                                            suffix={this.renderSuffixForPositionItem(p, index)}
                                                                                        />
                                                                                    </h1>
                                                                                    <div className='avTrx-details-box col-6 last-transaction fleet-good-group'>
                                                                                        {this.renderItemLastTransaction(p, index)}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                        : null}
                                                                    <label className='avTrx-details-label' key='lastTransaction-date'>
                                                                        {this.state.lastTransaction?.date &&
                                                                            moment.isDate(this.state.lastTransaction?.date)
                                                                            ? moment(this.state.lastTransaction?.date).format('DD.MM.YYYY')
                                                                            : ''}
                                                                        , {this.state.lastTransaction?.stationName}
                                                                    </label>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </BlockUi>
                                                </Card>
                                            </DivContainer>
                                        ) : (
                                            <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                                <Card header={this.renderLastTransactionHeader()}>
                                                    <BlockUi
                                                        tag='div'
                                                        blocking={this.state.loadingLastTransaction}
                                                        loader={this.loader}
                                                        loaderType='small-loader card-loader'
                                                        horizontal
                                                    >
                                                        <div className='row '>
                                                            {!!this.state.lastTransaction && !!this.state.lastTransaction.date ? (
                                                                <div className='col-12'>
                                                                    {this.state.lastTransaction?.transactionType === 2 ? (
                                                                        <div className='row last-transaction-row'>
                                                                            <h1 id={`last-trx-quantity-ev`} className='lastTrx col-6'>
                                                                                <NumberFormat
                                                                                    value={this.state.lastTransaction?.evQuantity}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator=' '
                                                                                    decimalSeparator=','
                                                                                    fixedDecimalScale
                                                                                    decimalScale={2}
                                                                                    renderText={(value) => value}
                                                                                    suffix={` ${this.state.lastTransaction?.quantityUnit}`}
                                                                                />
                                                                            </h1>
                                                                            <div className='avTrx-details-box col-6 last-transaction fleet-good-group'>
                                                                                {this.renderItemLastTransaction(
                                                                                    this.state.lastTransaction,
                                                                                    'ev'
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                    <label className='avTrx-details-label' key='lastTransaction-date'>
                                                                        {this.state.lastTransaction?.date &&
                                                                            moment.isDate(this.state.lastTransaction?.date)
                                                                            ? moment(this.state.lastTransaction?.date).format('DD.MM.YYYY')
                                                                            : ''}
                                                                        , {this.state.lastTransaction?.stationName}
                                                                    </label>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </BlockUi>
                                                </Card>
                                            </DivContainer>
                                        )}

                                        <DivContainer colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'>
                                            <Card className='banner-card'>
                                                <img
                                                    alt={t('card.banner.alt')}
                                                    src={
                                                        this.state.bannerImage
                                                            ? `/images/${this.state.bannerImage}`
                                                            : '/images/card_banner.png'
                                                    }
                                                    className='banner-user-image'
                                                />
                                            </Card>
                                        </DivContainer>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                            {this.renderCardData()}
                        </TabPanel>
                        <TabPanel header={`${t('cards.userDetails.limits')}`}>
                            <DivContainer colClass='dashboard'>
                                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <DivContainer colClass='col-12'>
                                            <Card header={this.renderRequiredHeader()}>
                                                <div className='row required-data'>
                                                    <InputCheckboxComponent
                                                        id={'vehicleRequired'}
                                                        name='vehicleRequired'
                                                        label={t('cards.registrationNumberFull')}
                                                        labelOnRight
                                                        value={this.state.element.vehicleRequired}
                                                        validator={this.validator}
                                                        onChange={this.handleChange}
                                                        viewMode={'EDIT'}
                                                        disabled
                                                        validators='not_required'
                                                        colClass='col-width-auto'
                                                    />
                                                    <InputCheckboxComponent
                                                        id={'driverRequired'}
                                                        name='driverRequired'
                                                        label={t('cards.fullName')}
                                                        labelOnRight
                                                        value={this.state.element.driverRequired}
                                                        validator={this.validator}
                                                        onChange={this.handleChange}
                                                        viewMode={'EDIT'}
                                                        disabled
                                                        validators='not_required'
                                                        colClass='col-width-auto'
                                                    />
                                                    <InputCheckboxComponent
                                                        id={'odometerRequired'}
                                                        name='odometerRequired'
                                                        label={t('cards.odometer')}
                                                        labelOnRight
                                                        value={this.state.element.odometerRequired}
                                                        validator={this.validator}
                                                        onChange={this.handleChange}
                                                        viewMode={'EDIT'}
                                                        disabled
                                                        validators='not_required'
                                                        colClass='col-width-auto'
                                                    />
                                                    <div className='mpk-div'>
                                                        <InputCheckboxComponent
                                                            id={'mpkRequired'}
                                                            name='mpkRequired'
                                                            label={t('cards.mpk')}
                                                            labelOnRight
                                                            value={this.state.element.mpkRequired}
                                                            validator={this.validator}
                                                            onChange={this.handleChange}
                                                            viewMode={'EDIT'}
                                                            disabled
                                                            validators='not_required'
                                                            colClass=''
                                                            iconSvg='ico_help_input_label_blue'
                                                            iconSize='mpk-icon'
                                                            iconSide='right'
                                                        />
                                                        <TooltipComponent
                                                            id='mpk-tooltip'
                                                            key='mpk-tooltip'
                                                            visible={this.state.mpkTooltipVisible}
                                                            content={t('cards.mpkTooltip')}
                                                            eventListeners={[
                                                                {
                                                                    eventName: 'mouseleave',
                                                                    fnc: this.handleHideTooltip,
                                                                    eventElementId: 'ico_help_input_label_blue',
                                                                },
                                                                {
                                                                    eventName: 'mouseenter',
                                                                    fnc: this.handleShowTooltip,
                                                                    eventElementId: 'ico_help_input_label_blue',
                                                                },
                                                            ]}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='profile edit mt-2'>
                                                    <ActionButton
                                                        label={t('details.editButton')}
                                                        variant='editButton white'
                                                        handleClick={this.handleOpenRequiredDialog}
                                                        iconSvg='ico_pencil'
                                                        iconSide='left'
                                                        disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                                    />
                                                </div>
                                            </Card>
                                        </DivContainer>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                            <DivContainer colClass='dashboard'>
                                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <DivContainer colClass='col-12'>
                                            <Card header={this.renderFleetGoodGroupHeder(t('cards.petrolHeader'))}>
                                                <div className='row-32'>{this.renderItems(this.state.element.petrols, 'petrols')}</div>
                                                {(!!this.state.element &&
                                                    !!this.state.element.fuelQuantityLimit &&
                                                    this.state.element.fuelQuantityLimit.type) ||
                                                    (!!this.state.element &&
                                                        !!this.state.element.fuelAmountLimit &&
                                                        this.state.element.fuelAmountLimit.type) ? (
                                                    <div className='row row-16'>
                                                        <label className='dashboard-label' key='card.limits'>
                                                            {t('cards.limits')}
                                                        </label>
                                                    </div>
                                                ) : null}
                                                <div className='limits-and-button'>
                                                    <div className='row'>
                                                        {this.renderFleetGoodGroupLimit(0, 'quantityLimit')}
                                                        {this.renderFleetGoodGroupLimit(0, 'amountLimit')}
                                                    </div>
                                                    <div className='profile edit'>
                                                        <ActionButton
                                                            label={t('details.editButton')}
                                                            variant='editButton white'
                                                            handleClick={() => this.handleOpenFleetGoodGroupDialog(0)}
                                                            iconSvg='ico_pencil'
                                                            iconSide='left'
                                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                                        />
                                                    </div>
                                                </div>
                                            </Card>
                                        </DivContainer>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                            {this.renderNotFuel('services', 1)}
                            {this.renderNotFuel('products', 2)}
                            {(this.authService.getProfile().agreementType === 'CASHLESS' && (this.state?.element?.cardKind === 'VEHICLE' || this.state?.element?.cardKind === 'VEHICLE_PERSON')) ? 
                    this.renderNotFuel('additionalServices', 2) : null}
                        </TabPanel>
                        <TabPanel header={`${t('details.management')}`}>
                            <DivContainer colClass='dashboard'>
                                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                                    <DivContainer colClass='row'>
                                        <DivContainer colClass='col-12'>
                                            <Card header={this.renderManagementHeader()}>
                                                <DivContainer colClass='row'>
                                                    <DataTable
                                                        id='dataTable'
                                                        key='data-table'
                                                        emptyMessage={this.translate('list.empty')}
                                                        className='p-datatable-responsive gray-no-header-table'
                                                        responsive
                                                        breakpoint='0px'
                                                        value={this.state.cardList}
                                                        sortOrder={-1}
                                                        rows={1}
                                                        lazy={false}
                                                    >
                                                        <Column field='cardType' body={this.renderCardIcon} />
                                                        <Column field='cardType' body={this.cardTypeTemplate} />
                                                        <Column field='status' body={this.statusTemplate} />
                                                        <Column field='phoneNumber' />
                                                        <Column field='expirationDate' body={this.expirationDateTemplate} />
                                                        <Column id='action-management' body={this.managementActionTemplate} />
                                                    </DataTable>
                                                    {!this.state.element.hasPlasticCard ? (
                                                        <div className='row'>
                                                            <ActionLink
                                                                // label={`${t('cards.orderPlasticCard')} ${
                                                                //     this.state.orderPlasticCardPrice
                                                                // } ${t('currency.pln')}`}
                                                                label={`${t('cards.orderPlasticCard')}`}
                                                                handleClick={this.handleOrderPlasticConfirmationOpen}
                                                                variant='blue'
                                                                // iconSize='icon-svg'
                                                                className='edit-blue-link under-table-button-left-icon'
                                                                key={'view-button'}
                                                                iconSide='left'
                                                                iconSvg='ico_blue_plus'
                                                                disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </DivContainer>
                                            </Card>
                                        </DivContainer>
                                    </DivContainer>
                                </DivContainer>
                            </DivContainer>
                        </TabPanel>
                    </TabView>
                </div>
            </React.Fragment>
        ) : null;
    }

    cardTypeTemplate(rowData) {
        const { t } = this.props;
        return <span className='bold font-14'>{t(`CardType.${rowData?.cardType}`)}</span>;
    }

    renderCardIcon(rowData) {
        return (
            <MenuItemIcon
                alt=''
                className={`icon-svg right`}
                iconSvg={rowData && rowData.cardType === 'PLASTIC' ? 'ico_plastic_card_type' : 'ico_virtual_card_type'}
            />
        );
    }

    statusTemplate(rowData) {
        const { t } = this.props;
        let statusColorClass = '';
        switch (rowData.status) {
            case 'ACTIVE':
                statusColorClass = 'green';
                break;
            case 'LOCKED':
                statusColorClass = 'red';
                break;
            case 'BLOCKED':
                statusColorClass = 'red';
                break;
            case 'EXPIRED':
                statusColorClass = 'red';
                break;
            case 'TO_BE_PRINTED':
                statusColorClass = '';
                break;
            case 'UNAUTHORIZED':
                statusColorClass = 'orange';
                break;
            default:
                statusColorClass = '';
                break;
        }
        if (rowData && rowData.status) {
            return <span className={`bold ${statusColorClass}`}>{t(`EcCardStatus.${rowData?.status}`)}</span>;
        } else {
            return '';
        }
    }

    expirationDateTemplate(rowData) {
        const { t } = this.props;
        if (rowData) {
            return (
                <React.Fragment>
                    <span className=''>{t('cards.validTo')}</span>
                    <span className='extra-bold'>
                        {!!rowData.indefinitely
                            ? t('cards.indefinitely')
                            : rowData.expirationDate && moment.isDate(rowData.expirationDate)
                                ? moment(rowData.expirationDate).format('DD.MM.YYYY')
                                : ''}
                    </span>
                </React.Fragment>
            );
        }
    }

    // handleBlockCard() {
    //     const {t} = this.props;
    //     this.scrollToTop();
    //     this.blockUi();
    //     if (this._isMounted) {
    //         this.service
    //             .blockCard(this.state.element.cardNumber)
    //             .then((response) => {
    //                 this.updateElement(response);
    //                 this.showSuccessMessage(t('cards.successBlockCard'));
    //             })
    //             .catch((err) => {
    //                 this.showErrorMessage(t('error.errorBlockCard'));
    //                 this.unblockUi();
    //             });
    //     }
    // }

    // handleUnblockCard() {
    //     const {t} = this.props;
    //     this.scrollToTop();
    //     this.blockUi();
    //     if (this._isMounted) {
    //         this.service
    //             .unblockCard(this.state.element.cardNumber)
    //             .then((response) => {
    //                 this.updateElement(response);
    //                 this.showSuccessMessage(t('cards.successUnblockCard'));
    //                 //this.unblockUi();
    //             })
    //             .catch((err) => {
    //                 this.showErrorMessage(t('error.errorUnblockCard'));
    //                 this.unblockUi();
    //             });
    //     }
    // }

    handleOrderPlasticCard() {
        const { t } = this.props;
        this.scrollToTop();
        this.blockUi();
        if (this._isMounted) {
            this.service
                .orderPlasticCard(this.state.element.cardNumber)
                .then((response) => {
                    this.setState({ orderPlasticConfirmationVisibile: false });
                    this.updateElement(response);
                    this.showSuccessMessage(t('cards.successOrderPlasticCard'));
                    //this.unblockUi();
                })
                .catch((err) => {
                    this.setState({ orderPlasticConfirmationVisibile: false }, () => {
                        this.showErrorMessage(t('error.errorOrderPlasticCard'));
                        this.unblockUi();
                    });
                });
        }
    }

    managementActionTemplate(rowData) {
        const { t } = this.props;
        if (rowData && rowData.cardType === 'VIRTUAL') {
            return (
                <React.Fragment>
                    {this.state.element?.authorized === true ? (
                        <ActionLink
                            label={t('cards.cardUnauthorizeHeader')}
                            handleClick={this.handleOpenUnauthorizeDialog.bind(this)}
                            variant='blue'
                            className='edit-blue-link'
                            key={'view-button'}
                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') || this.state.element?.dontResume === true}
                        />
                    ) : (
                        <ActionLink
                            label={t('cards.authorizeCardHeader')}
                            handleClick={this.handleOpenAuthorizeDialog.bind(this, rowData)}
                            variant='blue'
                            className='edit-blue-link'
                            key={'view-button'}
                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') || this.state.element?.dontResume === true}
                        />
                    )}
                </React.Fragment>
            );
        }
    }

    renderNotFuel(listName, index) {
        const { t } = this.props;
        const highwaysContractEnabled = this.authService.getProfile().highwaysEnabled === true ? true : false;
        const noPossibilityToEditWhenStandardUserAndAgreementTermsNotAcceptedByMainUser = this.authService.getProfile().userType === 'STANDARD' && this.checkTokenIfAllHighwaysAgreementNotAccepted() === true;
        let limitName = '';
        if (index === 2) {
            limitName = 'notFuelAmountLimit';
        } else if (index === 1) {
            limitName = 'serviceAmountLimit';
        }
        return (
            <DivContainer colClass='dashboard'>
                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                    <DivContainer colClass='row'>
                        <DivContainer colClass='col-12'>
                            <Card
                                header={this.renderFleetGoodGroupHeder(
                                    listName === 'services' ? t('cards.serviceHeader') : listName === 'additionalServices' ?  t('cards.additionalServicesHeader') : t('cards.productsHeader')
                                )}
                            >
                                {/* <div className='row-32'>{listName === 'additionalServices' ?  this.renderAdItems(this.state.element[listName], listName) :this.renderNotFuelItems(this.state.element[listName], listName)}</div> */}
                                <div className='row-32'>{listName === 'additionalServices' ?  this.renderAdditionalItems() :this.renderNotFuelItems(this.state.element[listName], listName)}</div>

                                {!!this.state.element && !!this.state.element[limitName] && this.state.element[limitName].type && listName !== 'additionalServices' ? (
                                    <div className='row row-16'>
                                        <label className='dashboard-label'>{t('cards.limits')}</label>
                                    </div>
                                ) : null}
                                <div className='limits-and-button'>
                                 {listName === 'additionalServices' ? <div/> : <div className='row'>{this.renderFleetGoodGroupLimit(index, 'amountLimit')}</div> }
                                    <div className='profile edit'>
                                        <ActionButton
                                            label={t('details.editButton')}
                                            variant='editButton white'
                                            handleClick={() => listName === 'additionalServices' ? this.handleOpenHighwayPaymentsDialog(index) : this.handleOpenFleetGoodGroupDialog(index)}
                                            iconSvg='ico_pencil'
                                            iconSide='left'
                                            rendered={listName === 'additionalServices' ? this.authService.getProfile().agreementType === 'CASHLESS' && this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') : true}
                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') || (listName === 'additionalServices' &&  (!this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') || highwaysContractEnabled === false ||(this.state?.element?.cardKind !== 'VEHICLE' && this.state?.element?.cardKind !== 'VEHICLE_PERSON') || noPossibilityToEditWhenStandardUserAndAgreementTermsNotAcceptedByMainUser) )}
                                       />
                                    </div>
                                </div>
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </DivContainer>
        );
    }

    renderBackLink(label, handleBack) {
        return (
            <ActionLink
                label={label}
                className='back-blue-link'
                handleClick={handleBack}
                variant='blue'
                iconName='mdi-arrow-left left-arrow-style'
                iconSide='left'
                iconSize='xs'
                iconColor='blue'
            />
        );
    }

    renderDetailsHeader() {
        return this.renderCardDetailsHeader();
    }

    returnCardIconLocation() {
        if((this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' || this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK') && this.state.element.hybridCard === true){
            if(this.authService.getAgreementSourceTypeFromToken() === 'SGB_BANK' ){
                return '/images/card_hybrid_sgb.png';
             }
             if(this.authService.getAgreementSourceTypeFromToken() === 'BPS_BANK' ){
                return '/images/card_hybrid_bps.png';
             }
        } else {
            if (this.state.element.multiEnergeticCard === true) {
                if (this.authService.getAgreementSourceTypeFromToken() !== 'EC') {
                    return '/images/card_header_electromobility_new.png'
                } else {
                    return '/images/card_header_electromobility_micro.png'
                }
            } else {
                if (this.authService.getAgreementSourceTypeFromToken() !== 'EC') {
                    if (this.authService.getProfile().agreementType === 'CASH') {
                        return `/images/card_header_cash_new.png`
                    }
                    else {
                        return '/images/card_header_cashless_new.png'
                    }
                } else {
                    if (this.authService.getProfile().agreementType === 'CASH') {
                        return `/images/card_header_cash_micro.png`
                    }
                    else {
                        return '/images/card_header_cashless_micro.png'
                    }
                }
            }
        }

    }

    renderCardDetailsHeader() {
        const { t } = this.props;
        const { status, expirationDate , hybridCard} = this.state.element;
        const renewalAvailable =
             expirationDate !== null && expirationDate !== undefined && moment(expirationDate).add(-60, 'day').isBefore(moment()) && (status === 'ACTIVE' || status === 'TO_BE_PRINTED') && this.state.element?.dontResume !== true; 
        return (
            <div className='user-details-header'>
                <div className='row'>
                    <div className='card-photo-container col-width-auto'>
                        <img
                            alt={t('card.photo.alt')}
                            src={this.returnCardIconLocation()}
                            className= {hybridCard === true ? 'header-hybrid-card-image' : 'header-card-image' }
                        />
                    </div>
                    <div className='card-info-container col-width-flex'>
                        <div className='row profile'>
                            <label className='card-info-label col-12'>{`${t('cards.cardDetailsHeader')} ${this.state.element.cardNumber
                                }`}</label>
                        </div>
                        <div className='row'>
                            <InputTextComponent
                                id='cardKind'
                                name='cardKind'
                                label={t('cards.cardKind')}
                                colClass='col-width-auto'
                                value={t(`EcCardKind.${this.state.element.cardKind}`)}
                                // renderValue={() => {
                                //     return (
                                //         <span>
                                //             {t(`EcCardKind.${this.state.cardKind}`)}
                                //             <MenuItemIcon
                                //                 alt=''
                                //                 className={`icon-svg right clickable-icon`}
                                //                 iconSvg={'ico_pencil'}
                                //                 handleClick={this.handleCardKindDialogOpen}
                                //             />
                                //         </span>
                                //     );
                                // }}
                                viewMode={'VIEW'}
                            />
                            <InputTextComponent
                                id='monthlyAmountLimit'
                                name='monthlyAmountLimit'
                                label={t('order-card.monthlyAmountLimitSummary')}
                                colClass='col-width-auto'
                                value={this.state.element.monthlyAmountLimit}
                                renderValue={() => {
                                    return (
                                        <span>
                                            {`${this.state.element?.monthlyAmountLimit ? this.state.element?.monthlyAmountLimit : '-'}`}
                                            {this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') && (
                                                <MenuItemIcon
                                                    alt=''
                                                    className={`icon-svg right clickable-icon`}
                                                    iconSvg={'ico_pencil'}
                                                    handleClick={this.handleAllTrxEditionOpen}
                                                />
                                            )}
                                        </span>
                                    );
                                }}
                                viewMode={'VIEW'}
                            />

                            <InputTextComponent
                                id={'dailyVisitLimit'}
                                name={'dailyVisitLimit'}
                                label={t('cards.dailyVisitLimit')}
                                value={`${this.state.element?.dailyVisitLimit ? this.state.element?.dailyVisitLimit : '-'}`}
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                viewMode={'VIEW'}
                                min={0}
                                inputStyle={{ width: '100%' }}
                                colClass='flex-inputs'
                                renderValue={() => {
                                    return (
                                        <span>
                                            {`${this.state.element?.dailyVisitLimit ? this.state.element?.dailyVisitLimit : '-'}`}
                                            {this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') && (
                                                <MenuItemIcon
                                                    alt=''
                                                    className={`icon-svg right clickable-icon`}
                                                    iconSvg={'ico_pencil'}
                                                    handleClick={this.handleVisitLimitEditionOpen}
                                                />
                                            )}
                                        </span>
                                    );
                                }}
                            />
                            {this.authService.getProfile().agreementType !== 'CASH' && (this.state.element.hasPlasticCard === true)? (
                                <InputTextComponent
                                    id='pin'
                                    name='pin'
                                    label={t('cards.plasticCardPin')}
                                    colClass='col-width-auto'
                                    value={this.state.element.pin}
                                    viewMode={'VIEW'}
                                    renderValue={() => {
                                        return (
                                            <span>
                                                {this.state.element.pin}
                                                {this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') && (this.authService.getProfile().helpdeskUserRole !== 'SALES_REPRESENTATIVE' && this.authService.getProfile().helpdeskUserRole !== 'REGIONAL_MANAGER') && (
                                                    <MenuItemIcon
                                                        alt=''
                                                        className={`icon-svg right clickable-icon`}
                                                        iconSvg={'ico_pencil'}
                                                        handleClick={this.handleEditPinOpen}
                                                    />
                                                )}
                                            </span>
                                        );
                                    }}
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className='col-width-auto button-column'>
                        <ActionButton
                            label={status !== 'LOCKED' && status !== 'BLOCKED' ? t('cards.cardBlockHeader') : t('cards.cardUnblockHeader')}
                            variant='button lock-card-button blue'
                            handleClick={(e) => {
                                e.preventDefault();
                                this.handleOpenChangeBlockedDialog();
                            }}
                            disabled={(status === 'BLOCKED' && (this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER')) || !this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                        />
                        <ActionButton
                            label={t('cards.cardRenewHeader')}
                            variant='button renew-card-button blue'
                            disabled={!renewalAvailable || !this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS') || (this.authService.getProfile().helpdeskUserRole === 'SALES_REPRESENTATIVE' || this.authService.getProfile().helpdeskUserRole === 'REGIONAL_MANAGER')}
                            handleClick={(e) => {
                                e.preventDefault();
                                this.setState({ renewVisibile: true });
                            }}
                        />
                    </div>
                </div>
                <div className='fleet-good-group-banner'>
                    {((this.authService.getProfile().agreementType === 'CASHLESS' || this.authService.getProfile().agreementType === 'PREPAID') && this.state.element.multiEnergeticCard === false) ? (
                        <BannerComponent
                            key={'header-banner'}
                            label={t('cards.bannerInfoEvHeader')}
                            iconSvg='ico_red_banner_alert_icon'
                            iconSide='left'
                            subLabel={this.returnSublabel()}
                            rendered={this.state.renderBanner}
                            variant='red-banner'
                        ></BannerComponent>
                    ) : null}
                </div>
            </div>
        );
    }

    vehicleTypeTemplate(data) {
        let fitOption = this.state.vehicleTypeOpt?.filter(vt => vt.code === data) || [];
        if (fitOption.length > 0) {
            return fitOption[0].label;
        } else {
            return '';
        }

    }

    returnSublabel() {
        const { cardOrderNewUrl, t } = this.props;
        return (
            <div>
                <ActionLink
                    label={t('cards.bannerInfoEvDetailsLink')}
                    handleClick={() => (window.location.href = `${cardOrderNewUrl}`)}
                    variant='blue'
                    className='edit-blue-link'
                    key={'view-button'}
                    disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                />
                <span>{t('cards.bannerInfoEvDetails')}</span>
            </div>
        );
    }

    renderCardData() {
        const { t } = this.props;
        const limitedAccess = this.authService.getProfile().limitedAccess === true ?  true : false;
        return (
            <DivContainer colClass='dashboard'>
                <DivContainer colClass='dashboard-link-container dashboard-link-container-profile '>
                    <DivContainer colClass='row'>
                        <DivContainer colClass='col-12'>
                            <Card header={this.renderCardDataHeader()}>
                                <div className='row row-24'>
                                    <InputTextComponent
                                        id='phoneNumber'
                                        name='phoneNumber'
                                        label={t('cards.phoneNumber')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.phoneNumber}
                                        viewMode={'VIEW'}
                                    // renderRequired
                                    />
                                    <InputTextComponent
                                        id='driver'
                                        name='driver'
                                        label={t('cards.fullName')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.driver}
                                        viewMode={'VIEW'}
                                        renderRequired
                                        renderLabel={() => {
                                            if (
                                                this.state?.element?.cardKind === 'PERSON' ||
                                                this.state?.element?.cardKind === 'VEHICLE_PERSON'
                                            ) {
                                                return (
                                                    <span className='row '>
                                                        <label
                                                            id={`driver-label-id`}
                                                            className='p-label left-label flex-inputs'
                                                            htmlFor={'driver'}
                                                        >
                                                            {t('cards.fullName')}
                                                        </label>
                                                        <label className='icon-svg right-label red-star flex-inputs'>*</label>
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <label id={`driver-label-id`} className='p-label' htmlFor={'driver'}>
                                                        {t('cards.fullName')}
                                                    </label>
                                                );
                                            }
                                        }}
                                        rendered={
                                            this.state?.element?.cardKind === 'PERSON' || this.state?.element?.cardKind === 'VEHICLE_PERSON'
                                        }
                                    />
                                    <InputTextComponent
                                        id='registrationNumber'
                                        name='registrationNumber'
                                        label={t('cards.registrationNumberFull')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.registrationNumber}
                                        viewMode={'VIEW'}
                                        renderRequired
                                        renderLabel={() => {
                                            if (
                                                this.state?.element?.cardKind === 'VEHICLE' ||
                                                this.state?.element?.cardKind === 'VEHICLE_PERSON'
                                            ) {
                                                return (
                                                    <span className='row '>
                                                        <label
                                                            id={`registrationNumber-label-id`}
                                                            className='p-label left-label flex-inputs'
                                                            htmlFor={'registrationNumber'}
                                                        >
                                                            {t('cards.registrationNumberFull')}
                                                        </label>
                                                        <label className='icon-svg right-label red-star flex-inputs'>*</label>
                                                    </span>
                                                );
                                            } else {
                                                return (
                                                    <label
                                                        id={`registrationNumber-label-id`}
                                                        className='p-label'
                                                        htmlFor='registrationNumber-label-id'
                                                        style={{ width: '100%' }}
                                                    >
                                                        {t('cards.registrationNumberFull')}
                                                    </label>
                                                );
                                            }
                                        }}
                                        rendered={
                                            this.state?.element?.cardKind === 'VEHICLE' ||
                                            this.state?.element?.cardKind === 'VEHICLE_PERSON'
                                        }
                                    />
                                    <InputTextComponent
                                        id='odometer'
                                        name='odometerRead'
                                        label={t('cards.odometer')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.odometerRead}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='mpk'
                                        name='mpk'
                                        label={t('cards.mpk')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.mpk}
                                        viewMode={'VIEW'}
                                    />
                                    <InputTextComponent
                                        id='vehicleType'
                                        name='vehicleType'
                                        label={t('cards.vehicleType')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.vehicleTypeTemplate(this.state.element.vehicleType)}
                                        viewMode={'VIEW'}
                                    />
                                    {limitedAccess ? 
                                       <InputTextComponent
                                        id='limitedAccess'
                                        name='limitedAccess'
                                        label={t('cards.limitedAccess')}
                                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                                        value={this.state.element.limitedAccess === true ? "TAK" : "NIE"}
                                        viewMode={'VIEW'}
                                    /> : null}
                                   
                                </div>
                                <div className='edit-footer-dashboard'>
                                    <div className='flex-inputs center-items'>
                                        <label className='icon-svg left-label red-star '>*</label>
                                        <label id={`required-fields-label-id`} className='p-label left-label ' htmlFor={'required-fields'}>
                                            {t('cards.requiredFields')}
                                        </label>
                                    </div>
                                    <div className='edit'>
                                        <ActionButton
                                            label={t('details.editButton')}
                                            variant='editButton white'
                                            handleClick={this.handleOpenCardDataEditDialog}
                                            iconSvg='ico_pencil'
                                            iconSide='left'
                                            disabled={!this.isUserHasPermission('PERMISSION_EDIT_FLEET_CARDS')}
                                        />
                                    </div>
                                </div>
                            </Card>
                        </DivContainer>
                    </DivContainer>
                </DivContainer>
            </DivContainer>
        );
    }

    handleGoToDetail(e, rowData, x) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ stepView: 'DETAILS', element: rowData });
    }

    renderAvTransactionCountHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: `${t('cards.avTransactionCountHeader')}${t(`months.${new Date().getMonth()}`)}`,
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderFleetGoodGroupHeder(label) {
        const headerItems = [
            {
                label,
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_fuel_dashboard',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderLastTransactionHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('cards.lastTransactionHeader'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderCardDataHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('cards.userDetails.cardData'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_dashboard_profile',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderRequiredHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('cards.requiredHeaderLabel'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_cards_wallet',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderManagementHeader() {
        const { t } = this.props;
        const headerItems = [
            {
                label: t('cards.assignedCardTypes'),
                type: 'LABEL',
                className: '',
                iconSvg: 'ico_card_wallet_dashboard',
            },
        ];
        return this.prepareHeader(headerItems);
    }

    renderSuffixForPositionItem(p, index){
        const { t } = this.props;
        // if(this.state.lastTransaction?.transactionType === 3){
        //     return " " + t(`measureUnit.${this.state.lastTransaction?.quantityUnit}`);
        // } else
        
        if(p.measureUnit !== null && p.measureUnit !== undefined){
            return " " + t(`measureUnit.${p.measureUnit}`)
        } else {
            return ` ${t('cards.l')}`
        }
       
    }

    renderItemLastTransaction(p, index) {
        const { t } = this.props;
        const color = p.color ? p.color : 'white';
        const fontColor = p.color ? 'white' : '#090E22';
        return (
            <label
                key={`last-transaction-${p.name}-${index}`}
                id={`last-transaction-${p.name}-${index}`}
                className={`product-label card-details ${p.color ? 'gray-border' : 'transparent-border product-not-fuel-label'}`}
                style={{ backgroundColor: `${color}`, color: `${fontColor}` }}
            >
                {p.transactionType === 2 ? p.evName : t(`products.${p.name}`)}
            </label>
        );
    }

    renderItems(list, name) {
        const { t } = this.props;
        let allSelected = false;
        let noneSelected = true;
        if (list && list.length) {
            list.forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                }
                if (el.selected) {
                    noneSelected = false;
                }
            });
        }
        return (
            <div className='row fleet-good-group'>
                {list && list.length > 0
                    ? list.map((p, index) => {
                        const color = p.color ? p.color : 'white';
                        const fontColor = p.color ? 'white' : '#090E22';
                        return allSelected || p.selected ? (
                            <label
                                key={`products-${p.name}-${index}`}
                                className={`product-label card-details gray-border`}
                                style={{ backgroundColor: `${color}`, color: `${fontColor}` }}
                            >
                                {t(`products.${p.name}`)}
                            </label>
                        ) : null;
                    })
                    : null}
                {!!noneSelected ? (
                    <label
                        key={`products-none-${list}`}
                        className={`product-label card-details gray-border`}
                        style={{ backgroundColor: 'white', color: '#090E22' }}
                    >
                        {t(`products.none.${name}`)}
                    </label>
                ) : null}
            </div>
        );
    }
    //ROZWIAZANIE DLA SAMYCH AUTOSTRAD A1 A4
    renderAdditionalItems() {
        const { t } = this.props;
        const { element } = this.state;
        const highwayName = t('cards.A1A4highway');
        if((this.state?.element?.cardKind === 'VEHICLE' || this.state?.element?.cardKind === 'VEHICLE_PERSON')){
            if (this.authService.getProfile().agreementType === 'CASHLESS' && this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES')) {
                if(element.highwayEnabled === true){
                    return (
                        <div className='row fleet-good-group'>
                            <div style={{paddingLeft:'inherit'}}>
                                <label
                                    key={`products-none-highway-name`}
                                    className={`product-label card-details gray-border`}
                                    style={{ backgroundColor: 'white', color: '#090E22' }}
                                >
                                    {highwayName}
                                </label>
                                {element.highwayVehicleType !== null ?
                                    <label
                                        key={`products-none-category`}
                                        className={`product-label card-details gray-border`}
                                        style={{ backgroundColor: 'white', color: '#090E22' }}
                                    >
                                        {t('cards.vehicleHighwayCategory') + " " + element.highwayVehicleType}
                                    </label> : null}
                              
                            </div>
                        </div>
                    );
                } else {
                    return <div className='row fleet-good-group'>
                        <div style={{ paddingLeft: 'inherit' }}></div><label
                            key={`products-none-highways`}
                            className={`product-label card-details gray-border`}
                            style={{ backgroundColor: 'white', color: '#090E22' }}
                        >
                            {t(`products.none.additionalServices`)}
                        </label></div>
                }
               
            } else {
                return (<div className='highways-permission-banner'>
                    <BannerComponent
                        key={'header-banner'}
                        label={t('cards.highwaysPermissionBanner')}
                        iconSvg='ico_red_banner_alert_icon'
                        iconSide='left'
                        rendered={this.state.renderBanner}
                        variant='red-banner'
                    ></BannerComponent> </div>
                )
            }
        }
    

    }

    // sortAdditionalServices(list){
    //     return list.sort((a, b) => {
    //         // Jeśli 'a' dotyczy autostrad pryw. to ma być jako pierwszy na liście
    //         if (a.name === 'HIGHWAYS_PRIVATE') return -1;
    //         // Jeśli 'b' dotyczy autostrad pryw. to ma być jako pierwszy na liście
    //         if (b.name === 'HIGHWAYS_PRIVATE') return 1;
    //         // Jeśli oba elementy nie dotyczą autostrad pryw. to  nie zmieniamy ich kolejności
    //         return 0;
    //       });
    // }

    // sortAdditionalServicesDialog(list){
    //     return list.sort((a, b) => {
    //         // Jeśli 'a' dotyczy autostrad pryw. to ma być jako pierwszy na liście
    //         if (a.name === 'HIGHWAYS_PRIVATE') return 1;
    //         // Jeśli 'b' dotyczy autostrad pryw. to ma być jako pierwszy na liście
    //         if (b.name === 'HIGHWAYS_PRIVATE') return -1;
    //         // Jeśli oba elementy nie dotyczą autostrad pryw. to  nie zmieniamy ich kolejności
    //         return 0;
    //       });
    // }

    renderAdItems(list, name) {
        const { t } = this.props;
        const { element } = this.state;
        let allSelected = false;
        let noneSelected = true;
        const sortedList = this.sortAdditionalServices(list);
        if (list && list.length) {
            list.forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                }
                if (el.selected) {
                    noneSelected = false;
                }
            });
        }

        if  ( this.authService.getProfile().agreementType === 'CASHLESS' && this.authService.isUserHasAnyPermission('PERMISSION_FULL_ACCESS_ADDITIONAL_SERVICES') &&
        (this.state?.element?.cardKind === 'VEHICLE' || this.state?.element?.cardKind === 'VEHICLE_PERSON') ) {
            if(!!noneSelected){
                return   ( <div className='row fleet-good-group'>
                    <label
                key={`products-none-`}
                className={`product-label card-details gray-border`}
                style={{ backgroundColor: 'white', color: '#090E22' }}
            >
                {t(`products.none.additionalServices`)}
            </label> </div>)
            } else if( list && list.length){
            return <div className='row fleet-good-group'>{list.map((p, index) => {
                const color = p.color ? p.color : 'white';
                const fontColor = p.color ? 'white' : '#090E22';
                    return p.name === "HIGHWAYS_PRIVATE" ?

                                <div className='row'>
                                    <label
                                        key={`products-none-highway-name`}
                                        className={`product-label card-details gray-border`}
                                        style={{ backgroundColor: 'white', color: '#090E22' }}
                                    >
                                        {t(`additional-services.${p.name}`)}
                                    </label>
                                    {element.highwayVehicleType !== null ?
                                        <label
                                            key={`products-none-category`}
                                            className={`product-label card-details gray-border`}
                                            style={{ backgroundColor: 'white', color: '#090E22' }}
                                        >
                                            {t('cards.vehicleHighwayCategory') + " " + element.highwayVehicleType}
                                        </label> : null}

                                    {p.name === "HIGHWAYS_PRIVATE" ? <Checkbox //dopytac czy ten checkbox ma byc czy nie?
                                        checked={element.highwayEnabled}
                                        //checked={p.selected}
                                        className={'col'}
                                        disabled={true}
                                    /> : null}
                                </div>


                 : allSelected || p.selected ? (
                            <label
                                key={`products-nf-${p.name}-${index}`}
                                className={`product-label card-details gray-border`}
                                style={{ backgroundColor: `${color}`, color: `${fontColor}` }}
                            >
                                {t(`additional-services.${p.name}`)}
                            </label>
                        ) : null;
                    })} </div>

            }


        } else {
            return (<div className='highways-permission-banner'>
                <BannerComponent
                    key={'header-banner'}
                    label={t('cards.highwaysPermissionBanner')}
                    iconSvg='ico_red_banner_alert_icon'
                    iconSide='left'
                    rendered={this.state.renderBanner}
                    variant='red-banner'
                ></BannerComponent> </div>
            )
        }

    }


    renderNotFuelItems(list, name) {
        const { t } = this.props;
        let allSelected = false;
        let noneSelected = true;
        if (list && list.length) {
            list.forEach((el) => {
                if (el.name === 'ALL' && el.selected) {
                    allSelected = true;
                }
                if (el.selected) {
                    noneSelected = false;
                }
            });
        }
        return (
            <div className='row fleet-good-group'>
                {list && list.length
                    ? list.map((p, index) => {
                        const color = p.color ? p.color : 'white';
                        const fontColor = p.color ? 'white' : '#090E22';
                        return allSelected || p.selected ? (
                            <label
                                key={`products-nf-${p.name}-${index}`}
                                className={`product-label card-details gray-border`}
                                style={{ backgroundColor: `${color}`, color: `${fontColor}` }}
                            >
                                {t(`products.${p.name}`)}
                            </label>
                        ) : null;
                    })
                    : null}
                {!!noneSelected ? (
                    <label
                        key={`products-none-`}
                        className={`product-label card-details gray-border`}
                        style={{ backgroundColor: 'white', color: '#090E22' }}
                    >
                        {t(`products.none.${name}`)}
                    </label>
                ) : null}
            </div>
        );
    }

    handleOpenCardDataEditDialog() {
        this.setState({ cardDataEditDialogVisibile: true });
    }

    handleCloseEditClientDialog(callback) {
        this.setState({ cardDataEditDialogVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleAllTrxEditionOpen() {
        this.setState({ allTrxLimitEditionVisibile: true });
    }

    handleVisitLimitEditionOpen() {
        this.setState({ visitLimitEditionVisibile: true });
    }

    handleAllTrxEditionClose(callback) {
        this.setState({ allTrxLimitEditionVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleVisitLimitEditionClose(callback) {
        this.setState({ visitLimitEditionVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenRequiredDialog() {
        this.setState({ requiredDialogVisibile: true });
    }

    handleCloseRequiredDialog(callback) {
        this.setState({ requiredDialogVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenFleetGoodGroupDialog(activeIndex) {
        this.setState({ fleetGoodGroupDialogVisibile: true, fggActiveIndex: activeIndex });
    }

    handleCloseFleetGoodGroupDialog(callback) {
        this.setState({ fleetGoodGroupDialogVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    checkTokenIfAllHighwaysAgreementNotAccepted(){
        const listOfAcceptedTerms = this.authService.getHighwaysAcceptedTerms();
        return this.state.highwaysApprovals.filter(el => !listOfAcceptedTerms.includes(el.petraAgreementId)).length > 0;

    }

    handleOpenHighwayPaymentsDialog(activeIndex) {
        if(this.checkTokenIfAllHighwaysAgreementNotAccepted() === true){
            this.setState({motorwaysDialogVisibile: false, highwaysAgreementsDialogVisibile: true});
        } else {
            this.setState({motorwaysDialogVisibile: true, highwaysAgreementsDialogVisibile: false});
        }

    }

    handleCloseHighwayPaymentsDialog(callback) {
        this.setState({motorwaysDialogVisibile: false, highwaysAgreementsDialogVisibile: false}, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleHighwaysAgreementDialogClose(callback) {
        if(this.checkTokenIfAllHighwaysAgreementNotAccepted() === false){
            this.setState({motorwaysDialogVisibile: true, highwaysAgreementsDialogVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        } else {
            this.setState({motorwaysDialogVisibile: false, highwaysAgreementsDialogVisibile : false}, () => {
                if (callback) {
                    callback();
                }
            });
        }

    }

    handleOpenUnauthorizeDialog() {
        this.setState({ backOffAuthVisibile: true });
    }

    handleCloseBackOffAuthDialog(callback) {
        this.setState({ backOffAuthVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenChangeBlockedDialog() {
        this.setState({ changeBlockedVisibile: true });
    }

    handleCloseChangeBlockedDialog(callback) {
        this.setState({ changeBlockedVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOrderPlasticConfirmationOpen() {
        this.setState({ orderPlasticConfirmationVisibile: true });
    }

    handleOrderPlasticConfirmationClose() {
        this.setState({ orderPlasticConfirmationVisibile: false });
    }

    handleEditPinOpen() {
        this.setState({ pinEditVisibile: true });
    }

    handleEditPinClose(callback) {
        this.setState({ pinEditVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleCardKindDialogOpen() {
        this.setState({ cardKindVisibile: true });
    }

    handleCardKindDialogClose(callback) {
        this.setState({ cardKindVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleOpenAuthorizeDialog(rowData, e) {
        this.setState({ authorizationVisibile: true, phoneNumber: rowData.phoneNumber });
    }

    handleCloseAuthorizationDialog(callback) {
        this.setState({ authorizationVisibile: false }, () => {
            if (callback) {
                callback();
            }
        });
    }

    handleCloseHybridAgreementDialog(callback) {
            this.setState({ authorizationVisibile: false, hybridAgreementsVisibile: false }, () => {
                if (callback) {
                    callback();
                }
            });
        }


}

CardDetailsContainer.defaultProps = {
    backUrl: '#/cards',
    cardOrderUrl: '#/cards',
    cardOrderNewUrl: '#/order-card-new',
};

CardDetailsContainer.propTypes = {};
export default withTranslation()(CardDetailsContainer);
